import React          from 'react';
import { Link }       from 'react-router-dom';
import * as PropTypes from 'prop-types';

import renderStaticSection from '../../../../templates/_common/utils/renderStaticSection';

const SearchInfoItem = (props) => {
  const {
          description,
          label,
          urlKey,
          close
        } = props;

  let content = {};

  try {
    content = JSON.parse(description);
  } catch (e) {
    return null;
  }

  return (
    <Link
      to={urlKey}
      className={'item new inline'}
      onClick={close}
    >
      <div>
        <div className={'title'}>
          {label}
        </div>
        <div className={'description'}>
          {content.SECTIONS.map((section, s) => renderStaticSection(section, s))}
        </div>
      </div>
    </Link>
  );
};

SearchInfoItem.propTypes = {
  close:       PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  label:       PropTypes.string.isRequired,
  urlKey:      PropTypes.string.isRequired
};

export default SearchInfoItem;